import { useRef } from "react";

import { Card, CardMedia, CardContent, CardActions, Typography, Button } from "@mui/material";
import { decompressToBase64, formatter } from "../../utils/common";
import "../Items/Item.css";
import Modal from "react-modal";
import ItemModal from "../Items/ItemModal.js";
import { AddToCart, GetCart, GetCount } from "../ShoppingCart/CartHandler.js";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CardImg } from "reactstrap";
import React from "react";

const apiUrl = process.env.REACT_APP_BASEURL;

function FeaturedCards(props) {
  // const buttonRight = document.getElementById('slideRight');
  // const buttonLeft = document.getElementById('slideLeft');
  const [featCards, setFeatCards] = useState([]);
  const [startCard, setStartCard] = useState(0);
  const [endCard, setEndCard] = useState(5);
  const [currFeatCards, setCurrFeatCards] = useState([]);
  const [activeItem, setActiveItem] = useState();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [itemQty, setItemQty] = useState(1);

    const addItem = (item) => {
      AddToCart(item.itemDescription, item.images, item.itemNumber, item.price, itemQty);
      props.setCartCount(GetCount());
    };



  let headers = new Headers({
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.token.token,
  });
  console.log(`Featured Value: ${props.featuredVal}`);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    const findFeatured = async () => {
      if (props.featuredVal === true) {

        await delay(2000); // Delay for 2 seconds
        console.log(`I am rednered here!!!`)
        axios.get(apiUrl + `/api/Items/GetFeaturedItems`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + props.token.token,
          },
        })
          .then((response) => {
            setFeatCards(response.data); // Make sure response.data is an array
          })
          .catch((error) => {
            console.log(error);
          });
      }
    };
    findFeatured();
  }, [props.featuredVal]);

  useEffect(() => {
    setCurrFeatCards(featCards.slice(startCard, endCard));
  }, [featCards, startCard]);

  Modal.setAppElement("#root");

  const onRequestClose = () => {
    setIsOpen(false);
    // setCartFunc(GetCart);
  };

  const handleClick = (item) => {
    setActiveItem(item);
    setIsOpen(true);
    props.setIsSwiper(false);
  };

  let handleMenuClick = (catName) => {
    let parentCategory = props.categories.find((category) =>
      category.children.some((child) => child.name === catName)
    );
    props.setCategory(parentCategory);
    navigate("/CategorySearchResults");
    //API CALL TO GET CATEGORY INFO AND SET CATEGORY GOES HERE.

    // sessionStorage.removeItem("category");
    // sessionStorage.setItem("category", category);
  };

  const buttonRightClick = () => {
    if (endCard + 5 > featCards.length) {
      setEndCard(featCards.length);
      setStartCard(featCards.length - 5);
    } else {
      setEndCard(endCard + 5);
      setStartCard(startCard + 5);
    }
  };

  const buttonLeftClick = () => {
    if (startCard - 5 < 0) {
      setStartCard(0);
      setEndCard(5);
    } else {
      setStartCard(startCard - 5);
      setEndCard(endCard - 5);
    }
  };

  // function sideScroll(element, direction, speed, distance, step) {
  //     let scrollAmount = 0;
  //     var slideTimer = setInterval(function () {
  //         if (direction === 'left') {
  //             element.scrollLeft -= step;
  //         } else {
  //             element.scrollLeft += step;
  //         }
  //         scrollAmount += step;
  //         if (scrollAmount >= distance) {
  //             window.clearInterval(slideTimer);
  //         }
  //     }, speed);
  // }


    const swiperRef = useRef(null);

  const renderFeatCards = () => {
    if (featCards.length === 0) {
      return (
        <div role="status" class="space-y-2.5 animate-pulse md:h-[15em] w-screen">
        <div class="flex items-center w-full">
          <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
        </div>
        <div class="flex items-center w-full max-w-[80em]">
          <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
        </div>
        <div class="flex items-center w-full max-w-[70em]">
          <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-80"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
        </div>
        <div class="flex items-center w-full max-w-[80em]">
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
        </div>
        <div class="flex items-center w-full max-w-[40em]">
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-32"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
        </div>
        <div class="flex items-center w-full max-w-[60em]">
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-80"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
        </div>
        <span class="sr-only">Loading...</span>
      </div>
      )
    } else {
      return (
        <div className={`md:max-w-6xl max-w-sm mx-auto py-8 overflow-hidden  ${props.isSwiper ? "block" : "hidden"}`}>
          <h2 className="text-2xl font-bold text-center mb-6">Featured Products</h2>

          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={50}
            slidesPerView={1}
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 10 },  // Small screens: 1 card
              640: { slidesPerView: 3, spaceBetween: 25 },  // Medium screens: 2 cards
              1024: { slidesPerView: 4, spaceBetween: 50 }, // Large screens: 3 cards
            }}
            navigation={true}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            className="px-5 py-4"
          >

            {currFeatCards &&
              currFeatCards.map((item) => (
                <SwiperSlide
                  onMouseEnter={() => swiperRef.current?.autoplay.stop()}
                  onMouseLeave={() => swiperRef.current?.autoplay.start()}
                  key={item.itemNumber} >
                  <>
                    <Card
                      className="w-64 sm:w-56 md:w-60 lg:w-64 h-[350px]   rounded-lg overflow-hidden p-3 shadow-md 
                transition-all duration-300 ease-in-out hover:shadow-[0px_5px_15px_rgba(0,0,0,0.37)] hover:scale-[1.03] group cursor-pointer
                flex flex-col justify-between"
                      onClick={() => handleClick(item)}
                    >
                      {/* Image Section */}
                      <div className="h-32 flex justify-center items-center bg-white">
                        <CardImg
                          top
                          className="card-picture"
                          src={
                            "data:image/png;base64," +
                            decompressToBase64(
                              item.images[0]?.compressedImageData
                            )
                          }
                          id={item.itemNumber + "Img"}
                          alt={item.itemNumber}
                        />
                      </div>

                      {/* Content Section (Moves Up on Hover) */}
                      <CardContent
                        className="flex-1 flex flex-col flex-grow justify-between p-2 transform transition-all duration-300 ease-in-out 
                   group-hover:-translate-y-2"
                      >
                        <Typography variant="h6" className="font-semibold text-gray-800 text-sm md:text-base">
                          {item.itemNumber}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          className="text-blue-500 cursor-pointer hover:underline text-xs md:text-sm"
                        >
                          {item.categoryName}
                        </Typography>
                        <Typography
                          variant="body2"
                          className="text-gray-600 mt-1 text-xs md:text-sm line-clamp-2 h-10"
                        >
                          {item.itemDescription}
                        </Typography>
                        {item.available !== null && (
                          <Typography variant="body2" className="text-green-600 font-medium text-xs md:text-sm">
                            {item.available}
                          </Typography>
                        )}
                      </CardContent>

                      {/* Price & Action Section (Moves Up on Hover) */}
                      <CardActions
                        className="p-2 flex justify-between items-center transform transition-all duration-300 ease-in-out 
                          group-hover:-translate-y-2"
                      >
                        <Typography variant="body1" className="font-bold text-gray-900 text-sm md:text-base min-w-[50px] text-right">
                          {formatter.format(item.price)}
                        </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          className="rounded-full text-xs md:text-sm w-34 h-9 flex justify-center items-center"
                          onClick={(e) => {
                          e.stopPropagation();
                          addItem(item)
                        }}
                        >
                          Add to Cart
                        </Button>
                      </CardActions>
                    </Card>
                  </>
                </SwiperSlide>
              ))}

          </Swiper>
          {isOpen ? (
            <ItemModal
              setIsSwiper={props.setIsSwiper}
              item={activeItem}
              onRequestClose={onRequestClose}
              cartCount={props.cartCount}
              setCartCount={props.setCartCount}
            />
          ) : null}
        </div>
      );
    }
  };

  // Please see my two questions:
  // https://stackoverflow.com/questions/68518868/errors-getting-react-modal-in-my-react-component
  // https://stackoverflow.com/questions/68512119/how-to-make-multiple-items-fit-on-one-row-in-reactjs
  // ... and these others
  // https://stackoverflow.com/questions/53109202/bootstrap-4-card-horizontal-scroll-issue
  // https://stackoverflow.com/questions/56392199/make-a-button-to-scroll-horizontally-in-div
  // class FeaturedCards extends React.Component {
  //     constructor() {
  //         super();
  //         this.state = {
  //             name: 'React',
  //             apiData: [],
  //             activeItem: null,
  //             isOpen: false
  //         };
  //     }

  //     async componentDidMount() {
  //         if(this.tokenString){
  //         const tokenString = sessionStorage.getItem("token");
  //         const token = JSON.parse(tokenString);}
  //         const buttonRight = document.getElementById('slideRight');
  //         const buttonLeft = document.getElementById('slideLeft');

  //         buttonRight.onclick = function () {
  //             var container = document.getElementById('container');
  //             sideScroll(container, 'right', 25, 300, 10);
  //         };

  //         buttonLeft.onclick = function () {
  //             var container = document.getElementById('container');
  //             sideScroll(container, 'left', 25, 300, 10);
  //         };

  //         let headers = new Headers({
  //             "Accept": "application/json",
  //             "Content-Type": "application/json",
  //             // 'Authorization': 'Bearer ' + token.token
  //         });

  //         // We may want to go back and use axios after all
  //         // See my benchmark: https://www.measurethat.net/Benchmarks/Show/14128/0/xhr-vs-fetch-vs-axios#latest_results_block
  //         const response = await fetch(apiUrl + `/api/Items/GetFeaturedItems`, {
  //             method: "GET",
  //             headers: headers
  //         });
  //         const json = await response.json();
  //         console.log(json);
  //         this.setState({ itemList: json });
  //     }

  //     render() {
  //         const items = this.state.itemList;
  //         const { isOpen } = this.state;
  //         const { activeItem } = this.state;

  //         let onRequestClose = () => {
  //             this.setState({ isOpen: false });
  //             this.props.setCartFunc(GetCart);

  //         }

  //         let handleClick = (item) => {
  //             this.setState({ activeItem: item });
  //             this.setState({ isOpen: true });
  //         }

  //         const handleMenuClick = (category) => {
  //             sessionStorage.removeItem("category")
  //             sessionStorage.setItem("category", category)
  //         };

  //         return (
  //             <span id="featItemsSpan">
  //                 <Button id="slideLeft" color="primary">{String.fromCharCode(8249)}</Button>
  //                 <CardGroup id="container" className="card-group-scroll">
  //                     {items && items.map(item =>
  //                         <>
  //                         <Card key={item.itemNumber}>
  //                             <CardImg top className="card-picture" src={"data:image/png;base64," + decompressToBase64(item.images[0]?.compressedImageData)} id={item.itemNumber + "Img"} alt={item.itemNumber} />
  //                             <CardBody className="card-body">
  //                                     <CardTitle tag="a" onClick={() => handleClick(item)} style={{ cursor: "pointer" }}>{item.itemNumber}</CardTitle><br/>
  //                                     <CardSubtitle tag="a" className="mb-2 text-muted" href="/categoryItems" onClick={() => handleMenuClick(item.categoryName)}>{item.categoryName}</CardSubtitle>
  //                                     {item.available !== null ? <><CardText className="card-description-short">{item.itemDescription}</CardText><CardText>{item.available}</CardText></> : <CardText className="card-description">{item.itemDescription}</CardText>}
  //                             </CardBody>
  //                             <CardFooter className="text-muted">{formatter.format(item.price)}</CardFooter>
  //                         </Card>

  //                         </>
  //                     )}
  //                 </CardGroup>
  //                 <Button id="slideRight" color="primary">{String.fromCharCode(8250)}</Button>
  //                 {isOpen ? <ItemModal item={activeItem} onRequestClose={onRequestClose} /> : null}
  //             </span>
  //         );
  //     }
  // }
  return <div className=" w-screen  md:px-10 sm:py-0 py-10 md:py-10 lg:py-10">{renderFeatCards()}</div>;
}
export default FeaturedCards;
